import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=6cc038e8&scoped=true&"
import script from "./Auth.vue?vue&type=script&lang=js&"
export * from "./Auth.vue?vue&type=script&lang=js&"
import style0 from "./Auth.vue?vue&type=style&index=0&id=6cc038e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc038e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cc038e8')) {
      api.createRecord('6cc038e8', component.options)
    } else {
      api.reload('6cc038e8', component.options)
    }
    module.hot.accept("./Auth.vue?vue&type=template&id=6cc038e8&scoped=true&", function () {
      api.rerender('6cc038e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Auth.vue"
export default component.exports